import Vue from 'vue'
import Vuex from 'vuex'
import casinoModule from './casino'
import integrationModule from './integration'
import gameModule from './game'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    casino: casinoModule,
    integration: integrationModule,
    game: gameModule
  }
});
